<template>
  <CenterCenter>
    <div class="main">
      <b-tabs class="tabContent" v-model="activeTab">
        <!-- TAB CAMERA -->
        <b-tab-item class="tabItem" :label="'Input / output'">
          <RecordIOSettings/>
        </b-tab-item>
        <!-- TAB SECTION HELPER -->
        <b-tab-item class="tabItem" :label="$t('settings.panel.titleSectionTime')">
          <RecordSectionSettings/>
        </b-tab-item>

        <div class="validateContainer">
          <w-button color="primary" size="small" @click="closePopUp()">{{
              $t('settings.panel.close')
            }}
          </w-button>
        </div>
      </b-tabs>
    </div>
  </CenterCenter>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import CenterCenter from '@/components/layout/CenterCenter.vue';
import PopUpTitle from '@/components/title/PopUpTitle.vue';
import WButton from '@/components/wrapper/w-button.vue';
import WHelp from '@/components/wrapper/w-help.vue';
import {closeWModal} from '@/utils/dialog';
import RecordIOSettings from '@/components/recorder/setup/RecordIOSettings.vue';
import RecordSectionSettings from '@/components/recorder/setup/RecordSectionSettings.vue';

@Component({
  components: {RecordSectionSettings, RecordIOSettings, WHelp, WButton, PopUpTitle, CenterCenter},
})
export default class RecordSettingPanel extends Vue {
  private activeTab: number = 0;

  public closePopUp() {
    closeWModal(this);
  }
}
</script>

<style scoped lang="scss">

.main {
  padding: 24px;
  padding-top: 16px;
  position: relative;
  max-width: 500px;
  width: 100%;
  height: 100%;
  min-width: 320px;
  background: #FFF;
  color: #1B3954;
  border-radius: 8px;
  margin: auto;
  min-height: 400px;

  .tabContent {
    height: 100%;

    .tabItem {
      min-height: 380px;
    }
  }


  .validateContainer {
    position: absolute;
    right: 0px;
    bottom: 0px;
  }
}

</style>
